import AccordionList from "./AccordionList";
export default AccordionList;
